import React, { useEffect, useState } from "react";
import "./Portfolio.css";
import resumeData from "../../../resumeData/resumeData";

import LinkIcon from "@material-ui/icons/Link";

const Portfolio = () => {
  const [btnActiveId, setBtnActiveId] = useState(1);
  const [btnActiveTech, setBtnActiveTech] = useState("all");
  const [filteredProject, setFilteredProject] = useState([]);
  const [mouseEnter, setMouseEnter] = useState(false);
  const [hover, setHover] = useState(false);

  const [scroll, setScroll] = useState(0);

  function handleScroll(event) {
    setScroll(window.scrollY - 3900);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const filteredProjects = resumeData[0].projects.filter((projects) => {
      return projects.technology.includes(btnActiveTech);
    });

    setFilteredProject(filteredProjects);
  }, [btnActiveTech]);

  const projects = (
    btnActiveTech === "all"
      ? resumeData[0].projects
      : filteredProject.length
        ? filteredProject
        : []
  ).map((projects, index) => {
    // Image URL directly from resumeData
    const projectImage = projects.image;

    return (
      <div
        key={projects.title}
        className="col-lg-4 col-md-6 col-sm-6 columns portfolio-item"
      >
        <div
          style={{
            backgroundColor: "#2f2d3e",
            padding: "16px",
            border: "1px solid #ffffff1a",
            borderRadius: "5px",
          }}
        >
          <div className="item-wrap">
            <a href={projects.url} target="blank" title={projects.title}>
              <img src={projectImage} alt={projects.title} />

              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                  <p>{projects.category}</p>
                </div>
              </div>

              <div className="link-icon">
                <LinkIcon />
              </div>
            </a>
          </div>

          <h5 className="mt-4 text-secondary title">
            {projects.title.split("-")[0]}
          </h5>

          <h6 className="mt-2 titleHead">{projects.summary}</h6>

          <h6 className="portfolio-technology mt-lg-1">
            {projects.technology.map((tech) => (
              <span key={tech}> {tech} </span>
            ))}
          </h6>
        </div>
      </div>
    );
  });

  const portfolioButtons = [
    {
      id: 1,
      title: "ALL",
      tech: "all",
    },
    {
      id: 3,
      title: "REACT JS",
      tech: "React",
    },
    {
      id: 4,
      title: "NODE JS",
      tech: "Node",
    },
    {
      id: 5,
      title: "E-COMMERCE",
      tech: "Ecommerce",
    },
  ];

  return (
    <section id="portfolio" className="container-fluid">
      <div
        className="row projects portfolio-container-top"
        style={{
          maxWidth: "1300px",
          margin: "auto",
        }}
      >
        <div className="col-md-12 collapseed">
          <div className="scroll-text">
            <p
              style={{
                transform: `translateX(${scroll}%)`,
              }}
            >
              PROJECTS
            </p>
          </div>

          <h2
            style={{
              color: "#00ffd5",
              textAlign: "center",
              marginTop: "-60px",
              marginBottom: "80px",
              fontSize: "36px",
              position: "relative",
              zIndex: 2,
            }}
          >
            MY PROJECTS
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "16px",
              }}
            >
              <div className="main">
                <div className="ball"></div>
              </div>
            </div>
          </h2>

          <div className="portfolio-btn-group">
            {portfolioButtons.map((btn) => (
              <div
                key={btn.id}
                className={`
                  ${
                    btnActiveId === btn.id
                      ? "portfolio-btn-active"
                      : "btn-transparent"
                  }
                  portfolio-btn
                `}
                onClick={() => {
                  setBtnActiveId(btn.id);
                  setBtnActiveTech(btn.tech);
                }}
              >
                <span>{btn.title}</span>
              </div>
            ))}
          </div>

          <div
            id="portfolio-wrapper"
            style={{
              color: "white",
            }}
          >
            {projects}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
